
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[publicId]/products/[productId]",
      function () {
        return require("private-next-pages/[publicId]/products/[productId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[publicId]/products/[productId]"])
      });
    }
  